module.exports = __webpack_public_path__ + "static/media/Cards.64d3c4ae.svg";